module.exports = __webpack_public_path__ + "media/images/newsletter/carpool-tile-6d9762c51381ee9a6541b48cafd5c59e.png";